module.exports = __webpack_public_path__ + "static/media/Holly Redahan.1249d553.png";